<app-loading-overlay
  class="users-table-loader"
  [loading]="showLoadingOverlay()"
>
  <table
    appTable
    clickable
    appTableSort
    class="users-table"
    [dataSource]="rows()"
    [appTableSortDisabled]="disableSorting()"
    [appTableSortActive]="orderBy() ?? ''"
    [appTableSortDirection]="orderDir() ?? ''"
    (sortChange)="onSortChange($event)"
  >
    <ng-container appTableColumnDef="name">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
        appTableSortHeader
      >
        {{ 'entities.user.table.header.name' | translate }}
      </th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="70%"
            height="1.25rem"
          />
        } @else {
          {{ user.firstName }} {{ user.lastName }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="email">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
        appTableSortHeader
      >
        {{ 'entities.user.table.header.email' | translate }}
      </th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="82%"
            height="1.25rem"
          />
        } @else {
          {{ user.email }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="role">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.user.table.header.role' | translate }}
      </th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="4rem"
            height="1.25rem"
          />
        } @else {
          <span
            appTag
            size="small"
          >
            {{ user.role.name }}
          </span>
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="firm">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.user.table.header.firm' | translate }}
      </th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="72%"
            height="1rem"
          />
        } @else {
          {{ user.firm?.name ?? '-' }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="status">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.user.table.header.status' | translate }}
      </th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="5rem"
            height="1.25rem"
          />
        } @else {
          <app-user-status-tag [user]="user" />
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="actions">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      ></th>
      <td
        *appTableCellDef="let user"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton size="2rem" />
        } @else {
          <app-table-row-actions-button
            [item]="user"
            [actions]="rowActions()"
          />
        }
      </td>
    </ng-container>

    <tr
      *appTableHeaderRowDef="displayedColumns(); sticky: true"
      appTableHeaderRow
    ></tr>
    <tr
      *appTableRowDef="let row; columns: displayedColumns()"
      appTableRow
      (click)="onRowClick($event, row)"
    ></tr>
    <tr *appTableNoDataRow>
      <td [attr.colspan]="displayedColumns().length">
        @switch (contentState()) {
          @case ('empty') {
            <ng-container *ngTemplateOutlet="emptyTpl() ?? defaultNoData" />
          }
          @case ('noResults') {
            <ng-container *ngTemplateOutlet="noResultsTpl() ?? defaultNoData" />
          }
          @case ('error') {
            <ng-container *ngTemplateOutlet="errorTpl() ?? defaultNoData" />
          }
        }
      </td>
    </tr>
  </table>
</app-loading-overlay>

<ng-template #defaultNoData>
  <app-table-state-card [title]="defaultNoDataTitleKey() | translate" />
</ng-template>
